<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="save" type="primary" :loading="loading" @click="handleSave">保存</a-button>
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
    </template>
    <a-row>
      <a-col
        span="12"
      >
        <a-tree
          show-line
          checkable
          :expandedKeys="expandedKeys"
          :checkedKeys="checkedKeys"
          :tree-data="treeData"
          @check="handleCheck"
          @expand="handleExpand"
        />
      </a-col>
      <a-col
        span="12"
        v-if="collapseList.length !== 0"
      >
        <a-collapse accordion>
          <a-collapse-panel
            v-for="(item, index) in collapseList"
            :key="index"
            :header="item.constraintCapabilityDesc"
          >
                       <p>{{item.constraintCapability}}</p>
            <a-collapse accordion>
              <a-collapse-panel
                v-for="(it, id) in item.children"
                :key="`${index}-${id}`"
                :header="it.constraintKeyDesc"
              >
                <p>{{ it.constraintValue }}</p>
              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>
                   <!-- <a-collapse-panel key="2" header="This is panel header 2" :disabled="false">
                     <p>{{ text }}</p>
                   </a-collapse-panel>
                   <a-collapse-panel key="3" header="This is panel header 3">
                     <p>{{ text }}</p>
                   </a-collapse-panel> -->
        </a-collapse>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  name: 'ChannelAbility',
  props: {
    channelId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      collapseList: [],
      allCheckedKeys: [] // 于用存放所有的选中的tree的key 包括半选中的
    }
  },
  watch: {
    channelId: {
      async handler (c) {
        if (c) {
          await this.getTotalChannelAbility()
          await this.initComponents()
          await this.channelConstraintQueryByChannel()
        }
      },
      immediate: true
    }
  },
  created () {
    // this.initComponents()
  },
  methods: {
    async channelConstraintQueryByChannel () {
      const response = await this.$http.channel.channelConstraintQueryByChannel({ channelId: this.channelId })
      const { data, msg, succ } = response
      if (!succ) {
        this.$message.error(msg)
      } else {
        const list = []
        for (const item of data) {
          const { constraintCapability } = item
          const keys = list.map(it => it.constraintCapability)
          if (keys.includes(constraintCapability)) {
            list.find(it => it.constraintCapability === constraintCapability).children.push(item)
          } else {
            const obj = {
              ...item,
              children: [item]
            }
            list.push(obj)
          }
        }
        this.collapseList = list
      }
    },
    async getTotalChannelAbility () {
      const { data, msg, succ } = await this.$http.channel.channelTotalCapabilityQuery({})
      if (!succ) {
        this.$message.error(msg)
        this.treeData = []
      } else {
        const treeData = this.$u.getTreeData(data)
        this.treeData = treeData
      }
    },
    async initComponents () {
      const response = await this.$http.channel.channelCapabilityQuery({ channelId: this.channelId })
      const { data, msg, succ } = response
      if (!succ) {
        this.$message.error(msg)
      } else {
        // const keys = this.$u.getCheckedKeys(this.treeData, data)
        const treeWithKeys = this.$u.getTreeData(data)
        const checkedLastChildren = this.$u.getTreeLastChildren(treeWithKeys)
        const keys = checkedLastChildren.map(it => it.key)
        this.checkedKeys = keys
      }
    },
    handleExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    handleCancel () {
      this.visible = false
    },
    handleCheck (checkedKeys, e) {
      const halfCheckedKeys = e.halfCheckedKeys
      this.allCheckedKeys = [...checkedKeys, ...halfCheckedKeys]
      this.checkedKeys = checkedKeys
    },
    async handleSave () {
      const checkedData = this.$u.getCheckedCodeTree(this.allCheckedKeys, this.treeData)
      const { msg, succ } = await this.$http.channel.channelCapabilityUpdate({
        channelId: this.channelId,
        channelCapabilities: checkedData
      })
      if (!succ) {
        this.$message.error(msg)
      } else {
        this.$message.success('保存成功!')
        this.handleCancel()
        this.$emit('success')
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
